<template>
	<video v-if="src" ref="video" :autoplay="this.visible" playsinline="true" loop="true" muted="true">
		<source ref="src" :src="src" />
	</video>
</template>

<script>
export default {
	props: ['src', 'visible'],
	watch: {
		visible( newValue ) {
			this.maybePlay();
		}
	},
	data() {
		return {
			reducedMotion: false,
		}
	},
	mounted() {
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
		const check = () => {
			if ( mediaQuery.matches ) {
				this.reducedMotion = true;
			} else {
				this.reducedMotion = false;
			}
		};

		check();
		mediaQuery.addEventListener('change', function () {
			check();
		});

		this.maybePlay();
	},
	methods: {
		maybePlay() {
			if ( this.visible && !this.reducedMotion ) {
				this.$refs.video.play();
			} else {
				if ( this.$refs.video ) {
					this.$refs.video.pause();
				}
			}
		}
	}
}
</script>

<style>

</style>